// extracted by mini-css-extract-plugin
module.exports = {"showMoreTextContainer":"ShowMoreText_showMoreTextContainer__z4FWA","hide":"ShowMoreText_hide__86Kzl"};